import React from "react";

import moment from "moment";
import { prefixandsupfix_dupont, textBold,tdTextSupfix } from "utils/Constant";
import { capitalize } from 'proptypes/StringProptype';

import {
  Table,
} from "reactstrap";

const CustomTable = ({
  striped = true,
  hover = false,
  ...props
}) => {
  const { data, columns } = props
  // console.log('data',data,'columns',columns)

  return (
    <div
    style={{
      overflowX: 'auto'
    }}
    className="scrollbarHidden"
    >
      <Table
        hover={hover}
        striped={striped}
        className='table-borderless'
      >
        <thead>
          <tr>
            <TableHeaders colums={columns} />
          </tr>
        </thead>

        <tbody>
          <TableRows data={data} colums={columns} />
        </tbody>
      </Table>
    </div>
  );
}

// crating the tableheaders function and handle the th for all table in application

const TableHeaders = (props) => {
  const { colums } = props
  return colums.map((header, index) => {
    if (header.headerName) {
      return <th style={{ textTransform: "capitalize", textAlign: index === 0 ? null : 'right' }} key={index} >{capitalize(header.headerName.replace(/_/g, " "))}</th>
    }


    else if (header.analysisName) {
      return <th className="text-center" style={{ textTransform: "uppercase", textAlign: index === 0 ? null : 'right' }} key={index} >{header.analysisName.replace(/_/g, " ")}</th>
    }


    else {
      return <th style={{ textTransform: "capitalize", textAlign: index === 0 ? null : 'right' }} key={index}>{index === 0 ? header.field : header.field ? moment(header.field).format('MMM YYYY') : null}</th>
    }

  })
}

// crating the tablerow function and handle the tr,th, and td for all tables in application
const TableRows = (props) => {
  const { data, colums } = props

  return data.map((row, index) => {
    return <tr key={index}>
      {
        colums.map((header, index) => {
          if (header.headerName) {
            return (index === 0 ?
              <th key={index}>{capitalize(row[header.headerName].replace(/_/g, " "))}</th>
              :
              <td style={{ textAlign: 'right' }} key={index}>{(row[header.headerName])}</td>)
          }

          else if (header.analysisName) {
            return (index === 0 ?
              <th className="text-center" key={index}>{row[header.analysisName]}</th>
              :
              <td style={{ textAlign: 'right' }} className="text-center" key={index}>{'' + row[header.analysisName]}</td>)
          }

          else {
            return (
              index === 0 ?
                <th key={index} >{
                  prefixandsupfix_dupont[row[header.field]] ?
                    capitalize(row[header.field].replace(/_/g, " ")) + '' + prefixandsupfix_dupont[row[header.field]].supfix
                    : textBold[row[header.field]] ?
                      <b>{capitalize(row[header.field].replace(/_/g, " "))}</b>
                      :tdTextSupfix[row[header.field]] ?
                      capitalize(row[header.field].replace(/_/g, " "))+' %'
                      : capitalize(row[header.field].replace(/_/g, " "))
                }
                </th>
                :
                <td style={{ textAlign: 'right' }} key={index}>{textBold[row[header.field]] ? <b>{(row[header.field])}</b> : (row[header.field])}</td>
            )
          }
        })
      }
    </tr>

  })
}

export default CustomTable;